import {Component, OnInit} from '@angular/core';
import {ModalController, NavController} from '@ionic/angular';
import {APIService} from 'src/app/API.service';
import {ActivatedRoute, Router} from '@angular/router';
import {EditTeamPage} from '../../edit-team/edit-team.page';
import {SessionService} from '../../services/session.service';
import {DataStore} from '@aws-amplify/datastore';
import {PermissionType, Team, User} from '../../../models';

@Component({
    selector: 'app-teams',
    templateUrl: './teams.page.html',
    styleUrls: ['./teams.page.scss'],
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class TeamsPage implements OnInit {
    cssClass: string;
    public teamList: any = [];
    showFilters = false;
    filters = {
        name: '',
        role: 'Tutti',
    };
    roleNames: any;
    private teamId: any;

    constructor(
        public apiService: APIService,
        public sessionService: SessionService,
        public navController: NavController,
        public router: Router,
        private route: ActivatedRoute,
        public modalController: ModalController,
    ) {
    }

    async ngOnInit() {
        await this.route.params.subscribe( async params => {
            this.teamId = params['id'];

            await this.refreshTeamList();
        });
    // await this.refreshTeamList();
    }

    ionViewDidEnter() {


        // make sure the newly styled content scrolls when needed
        document
            .querySelectorAll('.main-content')
            [
        document.querySelectorAll('.main-content').length - 1
            ].shadowRoot.querySelector('.inner-scroll')
            .setAttribute('style', 'height:100%');
    }

    private async refreshTeamList() {
        /*  let users = await DataStore.query(User);*/
        let id = null;
        let firstNode = [];
        this.teamList = [];
        
        if (this.teamId) {
            let x =  await DataStore.query(User, this.teamId);
            
            firstNode.push(x);
        } else {
            firstNode = await DataStore.query(User, s => s.addedBy('eq', null).permessions('ne', PermissionType.CLIENT));

        }
        

        for (let u of firstNode) {
            let nodes = await this.getUsersTree(u);
            this.teamList.push(nodes);
        }


        
        // const teams = await DataStore.query(Team);
        // for(const t of teams) {
        //     // const team = {...t, teammates : {}};
        //     // team.teammates['items'] = await DataStore.query(User, u => u.teamID("eq", team.id));

        //     // team
        //     this.teamList.push(t);
        // }

        // this.applyClassBySelection('bounceInRight');
    }

    private async getUsersTree(user: User) {
        let userModel = JSON.parse(JSON.stringify(user));
        userModel.nextNode = [];
        let downLines = await DataStore.query(User, l => l.addedBy('eq', user.id).permessions('ne', PermissionType.CLIENT));

        if (downLines.length == 0) {
            return userModel;
        }
        for (const downLineElement of downLines) {
            let x = await this.getUsersTree(downLineElement);
            userModel.nextNode.push(x);
            
        }
        return userModel;
        /*
        user.nextNode = await DataStore.query(User, l => l.addedBy('eq', user.id));
return user.nextNode = await getUsersTree(user)*/
        /*  for (const u of users) {
              let x = JSON.parse(JSON.stringify(u));
              x.nextNode = await DataStore.query(User, l => l.addedBy('eq', u.id));
          }*/

    }

    openTeam(event, teamId) {
        event.stopPropagation();
        this.cssClass = '';
        this.router.navigate(['/user', teamId]);
    }

    createTeam() {
        this.openEditTeamModal(null);
    }

    editTeam(teamId: string) {
        this.openEditTeamModal(teamId);
    }

    private async openEditTeamModal(teamId: any) {
        const modal = await this.modalController.create({
            component: EditTeamPage,
            componentProps: {teamId: teamId},
            cssClass: 'custom-modal',
        });
        await modal.present();
        await modal.onWillDismiss().then((data) => {
            this.refreshTeamList();
        });
    }

    async deleteTeam(teamId: string) {
        this.cssClass = '';

        if (confirm('Do you want to delete this Team')) {
            await DataStore.delete(Team, teamId);
            // let the animation finish its job
            setTimeout(() => {
                this.refreshTeamList();
            }, 1000);
        }
    }

    collpaseAll() {
        let nodes = document.querySelectorAll(`[class*=itm-]`) as NodeList;
        nodes.forEach((node) => {
            const nn = node as HTMLElement;
            nn.classList.remove("expanded");
        });
        nodes = document.querySelectorAll(`li > ul`) as NodeList;
        nodes.forEach((node) => {
            const nn = node as HTMLElement;
            nn.style.display = "none";
        });
    }

    expand(event, parentId: string) {
        
        event.stopPropagation();
        const parent = document.getElementById(parentId) as HTMLElement;
        parent.classList.remove("collapsed");
        parent.classList.add("expanded");
        const child = document.querySelector(`#${parentId} > ul`) as HTMLElement;
        child.style.display = "block";
    }

    collapse(event, parentId: string) {
        event.stopPropagation();
        const parent = document.getElementById(parentId) as HTMLElement;
        parent.classList.remove("expanded");
        parent.classList.add("collapsed");
        const child = document.querySelector(`#${parentId} > ul`) as HTMLElement;
        child.style.display = "none";
    }

    back() {
        this.navController.back();
    }

    applyClassBySelection(effect: string): void {
        this.cssClass = 'animated ' + effect;
    }

    openPage(s: string) {
    }


    filterUsers() {

    }
}
